import React, { useState } from 'react';
import { useHistory } from 'react-router-dom';
import { message } from 'antd';
import { usePostHog } from '@posthog/react';
import { consumeMagicLink, fetchMe } from 'api/auth';
import { useAnalytics } from 'analytics';
import UnauthLayout from 'components/UnauthLayout';
import { URLS } from 'components/Routes/urls';
import { ERROR_MESSAGE_EXPIRE_TOKEN } from 'pages/reset-password/constants';
import { Button, Typography } from 'ui-kit';
import { getMagicLinkToken } from 'utils/magicLinkToken';
import { takeNextUrl } from 'utils/nextUrl';
import './MagicLinkPage.scss';

export default function MagicLinkPage() {
  const history = useHistory();
  const posthog = usePostHog();
  const capture = useAnalytics();
  const [token] = useState(getMagicLinkToken);
  const [isExpired, setIsExpired] = useState(!token);
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleContinue = () => {
    setIsSubmitting(true);

    consumeMagicLink({ token })
      .then(() =>
        // Analytics only - the Host is signed in by now, so a failure here must not block them.
        fetchMe()
          .then((me) => {
            posthog?.identify(String(me.user_id), { email: me.email, role: me.role });
            capture('user_logged_in', { role: me.role, method: 'magic_link' });
          })
          .catch(() => undefined),
      )
      .then(() => {
        history.push(takeNextUrl() || URLS.STORES);
      })
      .catch((error) => {
        setIsSubmitting(false);

        if (error?.message === ERROR_MESSAGE_EXPIRE_TOKEN) {
          capture('magic_link_consume_failed', { reason: 'expired_or_invalid' });
          setIsExpired(true);
        } else {
          message.error(error?.message || 'Something went wrong. Try again.');
        }
      });
  };

  if (isExpired) {
    return (
      <UnauthLayout compact>
        <div className="MagicLinkPage">
          <div className="MagicLinkPage-copy">
            <Typography variant="h5">This link is used or expired</Typography>
            <Typography variant="body2" color="textGray">
              A sign-in link works once and expires after 15 minutes.
            </Typography>
          </div>
          <div className="MagicLinkPage-actions">
            <Button to={URLS.MAGIC_LINK_REQUEST} variant="contained" fullWidth>
              Request a new link
            </Button>
            <Button to="/login/" variant="text" color="primary" size="small" fullWidth>
              Use a password instead
            </Button>
          </div>
        </div>
      </UnauthLayout>
    );
  }

  return (
    <UnauthLayout compact>
      <div className="MagicLinkPage">
        <Typography variant="h5">Finish signing in</Typography>
        <div className="MagicLinkPage-actions">
          <Button variant="contained" fullWidth loading={isSubmitting} onClick={handleContinue}>
            Continue
          </Button>
        </div>
      </div>
    </UnauthLayout>
  );
}
